
import { selector } from '@/lib/selectors';

export const documentApprovalStampPositionSelector = selector(
  (state) => state.documents.document,
  (d) => d.sign.signPosition,
);
